import { ChangeDetectionStrategy, Component, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { getRandomId } from '../../utils/get-random-id';
import { BoschUiIconComponent } from '../bosch-ui-icon/bosch-ui-icon.component';
import { BoschUiIconNames } from '../bosch-ui-icon/bosch-ui-icon.constants';

@Component({
  selector: 'bosch-ui-chip',
  standalone: true,
  imports: [CommonModule, BoschUiIconComponent],
  templateUrl: './bosch-ui-chip.component.html',
  styleUrls: ['./bosch-ui-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiChipComponent {
  @Input() index = 0;
  @Input() imageSrc: string | null = null;
  @Input() icon: BoschUiIconNames | null = null;
  @Input() removable = false;
  @Input() fixed = false;
  @Input() selected = false;
  @Input() disabled = false;
  @Input() removed = new EventEmitter<void>();

  readonly id = getRandomId('chip');
  readonly closeIcon = BoschUiIconNames.CloseSmall;

  remove(): void {
    this.removed.next();
  }
}
